import { render, staticRenderFns } from "./CustomAttribute.vue?vue&type=template&id=615de4f8&scoped=true&"
import script from "./CustomAttribute.vue?vue&type=script&lang=js&"
export * from "./CustomAttribute.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttribute.vue?vue&type=style&index=0&id=615de4f8&lang=scss&scoped=true&"
import style1 from "./CustomAttribute.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615de4f8",
  null
  
)

export default component.exports